import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'market_rate_settings',
  inputShow: gql`
    query marketRateSettings($input: MarketRateSettingQueryInput) {
      marketRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Market Rate Settings',
    order: 7,
  },
};
